/* src/app/admin-dashboard/site-system/site-system-layout/site-system-layout.component.css */
/*# sourceMappingURL=site-system-layout.component.css.map */
